module.exports = __webpack_public_path__ + "pics.cce23bfa.png";